import { pushStag } from '@repo-level/core-front';
import Cookies from 'js-cookie';
import { useCallback, useState } from 'react';

export const useOrganicStag = () => {
  const [stag, setStag] = useState<string | null>(null);

  const syncStag = useCallback(async () => {
    const stagFromCookies = Cookies.get('stag');
    const stagValue = window.appConfig.STAG;

    if (stagFromCookies || !stagValue) return null;
    if (stag) return stag;

    await pushStag({ stag: stagValue });
    setStag(stagValue);

    return stagValue;
  }, [stag]);

  return { stag, syncStag };
};
